import React, { Component } from 'react';

import SEO, { breadcrumbSchema, SITE_URL } from '../common/SEO';
import Header from '../common/Header';
import Footer from '../common/Footer';

import What from './aiva/What';
import Benefits from './aiva/Benefits';
import SelfSpiel from '../common/SelfSpiel';
import FAQ from '../common/FAQ';
import { AIVA_FAQ_ITEMS, AIVA_FEATURES } from '../../constants';
import Preloader from '../../hocs/Preloader';

const AIVA_JSON_LD = [
  breadcrumbSchema([
    { name: "Home", path: "/" },
    { name: "AIVA", path: "/aiva" },
  ]),
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "AIVA",
    url: `${SITE_URL}/aiva`,
    description:
      "AIVA is an agentic AI assistant built by Fernan de Dios, combining large language models with agentic model integrations and OpenClaw support to converse, integrate, and take action.",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    creator: {
      "@type": "Person",
      name: "Fernan de Dios",
      url: SITE_URL,
    },
    featureList: AIVA_FEATURES.map((feature) => feature.title),
  },
];

class Aiva extends Component {
    render() {
        return (
            <div id="page-container" className="full-height">
                <SEO
                  title="AIVA: Agentic AI Assistant Built by Fernan de Dios"
                  description="AIVA is an agentic AI assistant built by Fernan de Dios, combining large language models like Claude and GPT with agentic model integrations and OpenClaw support to converse, integrate, and take action."
                  path="/aiva"
                  jsonLd={AIVA_JSON_LD}
                />
                <Header id="aiva-banner" title="A.I.V.A." sub="Agentic AI Virtual Assistant Platform" />
                <What  />
                <Benefits />
                <FAQ items={AIVA_FAQ_ITEMS} />
                <SelfSpiel />
                <Footer />
            </div>
        );
    }
}

export default Preloader(Aiva);
